module.exports = __webpack_public_path__ + "img/ed034e1.svg";